function BrandLogo({ size = "md", compact = false, className = "" }) {
  const sizes = {
    sm: compact ? "h-10 w-10" : "h-10 w-auto max-w-[140px]",
    md: compact ? "h-14 w-14" : "h-14 w-auto max-w-[260px]",
    lg: compact ? "h-20 w-20" : "h-20 w-auto max-w-[360px]",
  };

  const imageClass = `${sizes[size] || sizes.md} object-contain`;

  if (compact) {
    return (
      <div className={`flex items-center ${className}`.trim()}>
        <img src="/logo/svg/logo-03.svg" alt="Ferrovan Global LLP" className={imageClass} />
      </div>
    );
  }

  return (
    <div className={`flex items-center ${className}`.trim()}>
      <img src="/logo/svg/logo-02.svg" alt="Ferrovan Global LLP" className={`${imageClass} dark:hidden`} />
      <img src="/logo/svg/logo-02.svg" alt="Ferrovan Global LLP" className={`${imageClass} hidden dark:block`} />
    </div>
  );
}

export default BrandLogo;
